module.exports = __webpack_public_path__ + "img/share.a9e074ec.svg";